import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const Manufacturers = () => {
  const manufacturers = [
    // Major Semiconductors & ICs (from uploaded logos)
    { name: 'Texas Instruments', logo: '/logos/TexasInstruments-Logo.svg.png' },
    { name: 'STMicroelectronics', logo: '/logos/st_logo_2020_blue_no_tagline.png' },
    { name: 'NXP Semiconductors', logo: '/logos/NXP_logo_RGB_web.avif' },
    { name: 'Infineon Technologies', logo: '/logos/Infineon-Technologies-AG.webp' },
    { name: 'Microchip Technology', logo: '/logos/microchip-logo.avif' },
    { name: 'ON Semiconductor', logo: '/logos/onsemi-logo-placeholder-lg.jpg' },
    { name: 'Analog Devices', logo: '/logos/images.png' },
    { name: 'Renesas Electronics', logo: '/logos/images (1).png' },
    { name: 'Broadcom', logo: '/logos/images (2).png' },
    { name: 'Qualcomm', logo: '/logos/images (3).png' },
    { name: 'Maxim Integrated', logo: '/logos/Maxim_Integrated-Logo.wine.png' },
    { name: 'Xilinx', logo: '/logos/Xilinx-Logo.wine.svg' },
    { name: 'Lattice Semiconductor', logo: '/logos/Lattice_Logo_Color_TransparentBG.png' },
    { name: 'Micron Technology', logo: '/logos/Micron-Logo.jpg' },
    { name: 'Alliance Semiconductor', logo: '/logos/Alliance_Semiconductor_Logo.svg.png' },
    { name: 'Intel Corporation', logo: '/logos/Intel_logo_(2006-2020).svg.png' },
    { name: 'Samsung Semiconductor', logo: '/logos/Samsung_Semiconductor_(2005).svg' },
    { name: 'Toshiba Electronic', logo: '/logos/images.jpg' },
    { name: 'Rohm Semiconductor', logo: '/logos/Logo_ROHM.svg' },
    { name: 'Cypress Semiconductor', logo: '/logos/Cypress_Semiconductor-Logo.wine.png' },
    { name: 'SK Hynix', logo: '/logos/SK_Hynix.svg.png' },
    { name: 'Silicon Labs', logo: '/logos/images (4).png' },
    { name: 'Nexperia', logo: '/logos/images (5).png' },
    { name: 'Diodes Incorporated', logo: '/logos/images (6).png' },
    
    // Passive Components Manufacturers
    { name: 'Murata', logo: '/logos/murata-logo.png' },
    { name: 'TDK', logo: '/logos/TDK_logo_blue_1200_630.avif' },
    { name: 'Yageo', logo: '/logos/yageo.webp' },
    { name: 'Panasonic', logo: '/logos/Panasonic-logo.png' },
    { name: 'Vishay', logo: '/logos/Vishay_Intertechnology_logo.png' },
    { name: 'Kemet', logo: '/logos/KEMET-Logo-Blue.jpg' },
    { name: 'Würth Elektronik', logo: '/logos/Würth_Elektronik_Logo.svg.png' },
    { name: 'AVX Corporation', logo: '/logos/AVX_Corporation-Logo.wine.png' },
    { name: 'Bourns', logo: '/logos/bourns-logo-approved.avif' },
    { name: 'Nichicon', logo: '/logos/images (7).png' },
    { name: 'Rubycon', logo: '/logos/Rubycon_Corporation-Logo.wine.png' },
    { name: 'Coilcraft', logo: '/logos/images (8).png' },
    { name: 'Abracon', logo: '/logos/Abracon-approved-Logo-2023.jpg' },
    
    // Connector Manufacturers
    { name: 'Amphenol', logo: '/logos/Amphenol-Logo.wine.png' },
    { name: 'TE Connectivity', logo: '/logos/TE_Connectivity_logo.svg.png' },
    { name: 'Molex', logo: '/logos/download.png' },
    { name: 'JST', logo: '/logos/download (1).png' },
    { name: 'Hirose Electric', logo: '/logos/Hirose_Electric_company_logo.svg' },
    { name: 'JAE Electronics', logo: '/logos/download (2).png' },
    { name: 'Samtec', logo: '/logos/download (3).png' },
    { name: 'Harwin', logo: '/logos/download (4).png' },
    { name: 'Phoenix Contact', logo: '/logos/download (5).png' },
    { name: 'Weidmüller', logo: '/logos/download (6).png' },
    { name: 'Omron', logo: '/logos/Omron-Logo.jpg' },
    
    // Power & Protection
    { name: 'Littelfuse', logo: '/logos/littelfuse.jpg' },
    { name: 'Fuji Electric', logo: '/logos/images (9).png' },
    { name: 'Semikron', logo: '/logos/images (10).png' },
    { name: 'Wolfspeed', logo: '/logos/images (11).png' },
    { name: 'Eaton', logo: '/logos/images (12).png' },
    
    // Specialty & Industrial
    { name: 'Honeywell', logo: '/logos/ogp.png' },
    { name: 'FTDI', logo: '/logos/download.jpg' },
    { name: 'CUI Devices', logo: '/logos/image.jpg' },
    { name: 'C&K Switches', logo: '/logos/images (4).png' },
    { name: 'Schaffner', logo: '/logos/images (5).png' },
    { name: 'EPSON', logo: '/logos/images (6).png' },
    { name: 'Pulse Electronics', logo: '/logos/images (7).png' },
    { name: 'Nichicon', logo: '/logos/images (8).png' },
    { name: 'Eaton', logo: '/logos/images (9).png' }
  ];

  return (
    <div className="manufacturers-page">
      <div className="page-header">
        <div className="container mx-auto px-6 py-16">
          <h1 className="page-title">Our Manufacturers</h1>
          <p className="page-subtitle">
            We supply components from leading global manufacturers with full traceability and quality assurance
          </p>
        </div>
      </div>

      <div className="container mx-auto px-6 py-12">
        <div className="mb-12 text-center">
          <div className="manufacturer-intro">
            <p className="text-lg mb-4">
              Shree Techno Products maintains strong partnerships with world-renowned semiconductor 
              and electronic component manufacturers. All our products come with complete documentation, 
              ensuring authenticity and reliability.
            </p>
            <p className="text-sm font-semibold text-blue-600">
              Partnered with {manufacturers.length}+ Leading Manufacturers Worldwide
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {manufacturers.map((manufacturer, index) => (
            <Card key={index} className="manufacturer-logo-card">
              <CardContent className="p-6 flex items-center justify-center min-h-[140px]">
                <img 
                  src={manufacturer.logo}
                  alt={manufacturer.name}
                  className="manufacturer-logo-image"
                  title={manufacturer.name}
                />
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-16">
          <Card className="quality-assurance-card">
            <CardContent className="p-8">
              <h3 className="text-2xl font-bold mb-4 text-center">Quality Assurance</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
                <div className="assurance-item">
                  <div className="assurance-number">100%</div>
                  <p className="assurance-text">Genuine Components</p>
                </div>
                <div className="assurance-item">
                  <div className="assurance-number">Full</div>
                  <p className="assurance-text">Traceability</p>
                </div>
                <div className="assurance-item">
                  <div className="assurance-number">Certified</div>
                  <p className="assurance-text">Quality Documentation</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600">
            Don't see a manufacturer you're looking for? Contact us - we have access to a broader network of suppliers.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Manufacturers;
